import { render, staticRenderFns } from "./NovoPlano.vue?vue&type=template&id=7c52e0f8&"
import script from "./NovoPlano.vue?vue&type=script&lang=js&"
export * from "./NovoPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports